import { Dispatch } from "redux";
import api from "../../api/api";
import {
  setcreateLessonsSuccess,
  setloading,
  seterror,
  resetcreateLessonsStatus,
} from "../reducers/createLessonsReducer";

/** POST `courses/<course_id>/create-lessons/` */
export interface CreateLessonsPayload {
  teacher: number;
  status: number;
  is_personalize: boolean;
  lesson_count: number;
}

function mapSuccessBody(body: any) {
  const lessons = Array.isArray(body?.data) ? body.data : null;
  return {
    success: Boolean(body?.success),
    message: (body?.message as string) ?? null,
    courseId: body?.course_id != null ? Number(body.course_id) : null,
    courseName: (body?.course_name as string) ?? null,
    lessonsCreated:
      body?.lessons_created != null ? Number(body.lessons_created) : null,
    lessons,
  };
}

/**
 * Bulk-create AI lessons for a course.
 * POST `courses/<course_id>/create-lessons/`
 */
const createLessons =
  (
    courseId: number | string,
    data: CreateLessonsPayload | FormData,
    token: string,
  ) =>
  async (dispatch: Dispatch): Promise<{ ok: boolean; message?: string }> => {
    dispatch(setloading(true));
    try {
      const isFormData =
        typeof FormData !== "undefined" && data instanceof FormData;

      const headers: Record<string, string> = {
        Authorization: `Token ${token}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
      };

      const result = await api.post(
        `courses/${courseId}/create-lessons/`,
        data,
        { headers },
      );

      dispatch(setloading(false));

      const body = result?.data as Record<string, unknown> | undefined;
      const httpOk = result?.status === 200 || result?.status === 201;

      if ((body as any)?.status === 404) {
        const msg = String((body as any)?.message ?? "Resource not found.");
        dispatch(seterror(msg));
        return { ok: false, message: msg };
      }

      if (body?.success === true && Array.isArray((body as any)?.data)) {
        dispatch(setcreateLessonsSuccess(mapSuccessBody(body)));
        const msg =
          typeof (body as any)?.message === "string"
            ? (body as any).message
            : undefined;
        return { ok: true, message: msg };
      }

      if (httpOk && Array.isArray((body as any)?.data)) {
        dispatch(
          setcreateLessonsSuccess({
            ...mapSuccessBody({ ...body, success: true }),
          }),
        );
        const msg =
          typeof (body as any)?.message === "string"
            ? (body as any).message
            : undefined;
        return { ok: true, message: msg };
      }

      const errMsg = String(
        (body as any)?.message ??
          (body as any)?.detail ??
          "Something went wrong.",
      );
      dispatch(seterror(errMsg));
      return { ok: false, message: errMsg };
    } catch (error: any) {
      dispatch(setloading(false));
      const msg = String(
        error?.response?.data?.message ??
          error?.response?.data?.detail ??
          "Something Went Wrong!",
      );
      dispatch(seterror(msg));
      return { ok: false, message: msg };
    }
  };

export { createLessons, resetcreateLessonsStatus };